import Vue from 'vue'
import VueRouter from 'vue-router'
import RootComponent from './components/RootComponent.vue'
import routes from './routes'
import store from './store'
import storePlugin from './storePlugin'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon.vue'
import VueTranslate from 'vue-translate-plugin'
import VueCarousel from 'vue-carousel';
import 'babel-polyfill'
import 'es6-promise/auto'
import Es6Promise from 'es6-promise'
import $ from 'jquery'
import Vuebar from 'vuebar'
import vueTopprogress from 'vue-top-progress'

Es6Promise.polyfill()

Vue.use(Vuebar)
Vue.use(VueCarousel);
Vue.component('icon', Icon)
Vue.use(VueRouter)
Vue.use(storePlugin)
Vue.use(VueTranslate) 
Vue.use(vueTopprogress)

const router = new VueRouter({
  base: __dirname,
  mode: 'history',
  base: window.location.pathName,
  routes
});

// Drupal.behaviors.app = {
//   attach: function (context, settings) {
    new Vue({
      el: '#app',
      render: h => h(RootComponent),
      router,
      store
    }) 
//   }
// };
